import { motion } from "framer-motion";
import { Instagram } from "lucide-react";


export const Founder = () => (
  <section id="founder" className="py-28 lg:py-36" data-testid="founder-section">
    <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-7">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">Our founding story</p>
        <h2 className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl">
          It began with her children. <span className="text-primary">It became her own becoming.</span>
        </h2>
        <figure className="mt-10 max-w-sm" data-testid="founder-portrait">
          <img src="/photos/zarya-thomas.webp" alt="Zarya Thomas, founder of Nia Ecoversity, smiling in sunlight"
            className="aspect-[4/5] w-full rounded-sm border border-border object-cover" data-testid="founder-photo" />
          <figcaption className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-foreground/60">Zarya Thomas, founder</figcaption>
        </figure>
        <div className="mt-10 space-y-6 text-base leading-relaxed text-foreground/80 sm:text-lg">
          <p>
            Nia Ecoversity is founded by <strong className="font-semibold text-primary" data-testid="founder-name">Zarya Thomas</strong>,
            who has spent more than a decade deschooling herself and unschooling her family.
          </p>
          <p>
            "I started deschooling because of my children. I didn't know at the time how much it was going to ask me to deschool myself."
          </p>
          <p>
            Learning to trust her children's timing, stop measuring their learning, listen to their no and honour their interests
            led her to a harder question: "Do I offer any of that freedom to myself?"
          </p>
        </div>
        <motion.blockquote initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="mt-12 border-l-4 border-primary pl-6 font-display text-3xl font-medium leading-snug text-foreground sm:text-4xl" data-testid="founder-quote">
          "My children became mirrors. And eventually I realized... I was deschooling myself."
          <footer className="mt-4 font-sans text-sm tracking-wide text-foreground/60">— Zarya Thomas, founder</footer>
        </motion.blockquote>
      </div>
      <div className="lg:col-span-5">
        <div className="sticky top-28 rounded-sm border border-border bg-card p-10" data-testid="founder-practice-card">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-foreground/60">A reflection practice by Zarya</p>
          <img src="/brand/ntqr-mirror.jpg" alt="Notice, Trace, Question, Reimagine illustrated in a mirror"
            className="mt-6 w-full rounded-sm" data-testid="founder-practice-image" />
          <p className="mt-10 text-sm leading-relaxed text-foreground/70">
            "Most of these beliefs didn't begin with us. But once we can see them... we get more choice about what happens next."
          </p>
          <div className="mt-8 flex items-center gap-2 border-t border-border pt-6 text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            Keep questioning. Keep becoming. Keep shining.
          </div>
          <img src="/brand/rise-and-shiny.jpg" alt="Rise & Shiny: learning, healing, becoming" className="mt-6 w-full rounded-sm" data-testid="founder-rise-shiny-logo" />
          <a href="https://www.instagram.com/riseandshiny_/" target="_blank" rel="noopener noreferrer" data-testid="founder-instagram-link"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary underline decoration-gold decoration-2 underline-offset-8 transition-colors hover:text-primary">
            <Instagram className="h-4 w-4" /> @riseandshiny_
          </a>
        </div>
      </div>
    </div>
  </section>
);
